import { Avatar, Box, Button, Grid2, Paper, Tab, Tabs, Tooltip, Typography, useTheme } from "@mui/material";
import { OverridableComponent } from "@mui/types";
import { SvgIconTypeMap } from "@mui/material";
import { CrisisAlert, Event, Handyman, LocalParking, MeetingRoom, Person } from "@mui/icons-material";
import { Announcements, Booking, UnitType, User, UserType, ViewServiceRequestData, Violation, VisitorParkingRequest } from "../../Types/UnitFeatureTypes";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUnit } from "../../Redux/selectors";
import DropdownSelection from "../CommonComponents/DropdownSelection";
import BuildAnnouncementTable from "../BuildTables/BuildAnnouncementTable";
import BuildBookingsTable from "../BuildTables/BuildBookingsTable";
import BuildServiceRequestsTable from "../BuildTables/BuildServiceRequestsTable";
import BuildViolationsTable from "../BuildTables/BuildViolationsTable";
import BuildVisitorParkingTable from "../BuildTables/BuildVisitorParkingTable";
import { useLocation } from "react-router-dom";
import dayjs from 'dayjs';
import UserCard from "../CommonComponents/UserCard";
import UnitCard from "../CommonComponents/UnitCard";
import { Actions, RootState } from "../../Redux/Reducer/rootReducer";
import DatePickerComponent from "../CommonComponents/CustomDatePicker";

const ViewUnitFile: React.FC = () => {

    const unitData = useSelector(fetchUnit);
    const [unitNumber, setUnitNumber] = useState<string>('');
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [currentTab, setCurrentTab] = useState<string>('Bookings');
    const unitFileData = useSelector((state: RootState) => state.fetchUnit.request.unitFile);
    const [fromDate, setFromDate] = useState<Date>(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [toDate, setToDate] = useState<Date>(new Date());
    const location = useLocation();
    const tableHeaders = [
        'Bookings',
        'Service Requests',
        'Reported Violations',
        'Visitor Parking'
    ]

    const metricInfo = [
        {
            "value": unitFileData?.visitorParkings?.length,
            "metric": "Parking Days Used",
            "icon": LocalParking
        },
        {
            "value": unitFileData?.serviceRequests?.length,
            "metric": "Service Requests",
            "icon": Handyman
        },
        {
            "value": unitFileData?.violations?.length,
            "metric": "Reported Violations",
            "icon": CrisisAlert
        },
        {
            "value": unitFileData?.unitInfo?.tenants?.length,
            "metric": "Active Tenants",
            "icon": Person
        },
        {
            "value": unitFileData?.bookings?.length,
            "metric": "Bookings Made",
            "icon": Event

        }
    ]

    const theme = useTheme();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(Actions.fetchUnit.unitFileActions.success({
            unitFile: undefined
        }));
    }, []);

    const handleGetUnitInfo = () => {
        if (unitNumber === '') {
            setErrors({ unitNumber: 'Unit Number is required' });
            return;
        }
        dispatch(Actions.fetchUnit.unitFileActions.request({ id: parseInt(unitNumber), fromDate, toDate }));
    }

    useEffect(() => {
        if (unitFileData) {
            console.log(unitFileData);
        }
    }
    , [unitFileData]);
    useEffect(() => {
        if (location?.state?.unit_id) {
            setUnitNumber(location.state.unit_id);
        }
    }, [location]);

    const getHeaderInfo = () => {
        return <Paper elevation={3} sx={{mb: 2, padding: 2, borderRadius: 3, alignItems: 'center'}}>
                <Grid2 container spacing={2}>
                    <Grid2 size={{xs: 3}}>
                    <Typography variant="h6">Unit File</Typography>
                    </Grid2>
                    <Grid2 size={{xs: 2}}>
                    <Tooltip title="Unit Dropdown">
                        <DropdownSelection
                            dropDownLabel='Select Unit'
                            showHeader={false}
                            currentValue={unitNumber}
                            selectionValues={unitData.map((unit) => ({
                                value: unit.id.toString(),
                                label: unit.unit_number.toString(),
                                color: theme.palette.text.primary,
                                icon: MeetingRoom,
                            }))}
                            showError={!!errors.unitNumber}
                            helperText={errors.unitNumber}
                            variant='outlined'
                            // sxObject={{ width: '100%' }}
                            handleOnChange={(e) => {setUnitNumber(e.target.value); setErrors({});}}
                        />
                    </Tooltip>
                    </Grid2>
                    <Grid2 size={{xs: 2}}>
                    <DatePickerComponent
                        labelValue="From Date"
                        selectedDate={dayjs(fromDate)}
                        setSelectedDate={(newDate) => setFromDate(newDate!.utc().toDate())}
                        maxDate={dayjs()}
                        
                    />
                    </Grid2>
                    <Grid2 size={{xs: 2}}>
                    <DatePickerComponent
                        labelValue="To Date"
                        selectedDate={dayjs(toDate)}
                        setSelectedDate={(newDate) => setToDate(newDate!.utc().toDate())}
                        minDate={dayjs(fromDate)}
                        maxDate={dayjs()}
                    />
                    </Grid2>
                    <Grid2 size={{xs: 3}}>
                        <Tooltip title="Get Unit Information">
                            <Button variant="contained" color="primary" onClick={handleGetUnitInfo}>Get Unit Information </Button>
                        </Tooltip>
                    </Grid2>
                </Grid2>
        </Paper>
    }

    const buildInfoCard = (icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>, title: string, data: any) => {
    return (
        <Paper elevation={3} sx={{ borderRadius: 3, m:2, textAlign: 'center', background: '#f4f4f4' }}>
        <Paper elevation={5} sx={{ paddingInline: 1, borderRadius: 6, display: 'flex', justifyContent: 'space-between'}}>
            {React.createElement(icon, { sx: { fontSize: 40, color: '#3f51b5', margin: 'auto 0' } })}
            <Typography variant="h6" sx={{maxWidth: 150, fontWeight: 600, textAlign: 'start'}}>{title}</Typography>
        </Paper>
        <Typography variant="h5" sx={{marginBlock: 4}}>{data}</Typography>
        </Paper>
    );
    }

    const buildTabs = () => {
        return (
            <Paper elevation={3} sx={{mb: 2, padding: 2, borderRadius: 3}}>
                <Tabs variant="scrollable" scrollButtons value={currentTab} onChange={(event: React.SyntheticEvent, newValue: string) => setCurrentTab(newValue)}>
                    {tableHeaders.map((title) => {
                        return (
                            <Tab sx={{flexGrow: 1}} label={title} value={title} />
                        )
                    })}
                </Tabs>
            </Paper>
        )
    }

    const buildTable = (title: string) => {
        // if (title === 'Announcements') return <BuildAnnouncementTable item={tableData[title] as Announcements[]} />;
        if (title === 'Bookings') return <BuildBookingsTable item={unitFileData?.bookings as Booking[]} showActions={false} />;
        if (title === 'Service Requests') return <BuildServiceRequestsTable item={unitFileData?.serviceRequests as ViewServiceRequestData[]} />;
        if (title === 'Reported Violations') return <BuildViolationsTable item={unitFileData?.violations as Violation[]} showActions={false} />;
        if (title === 'Visitor Parking') return <BuildVisitorParkingTable item={unitFileData?.visitorParkings as VisitorParkingRequest[]} showActions={false} />;
        return null;
    };

    const showOwnerInfo = () => {
        return <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mb: 2}}>
            <UserCard user={unitFileData?.unitInfo?.owner} isOwner={true} />
            <UnitCard unit={{
                id: unitFileData?.unitInfo?.id,
                unit_number: unitFileData?.unitInfo?.unit_number,
                unit_type: unitFileData?.unitInfo?.unit_type,
                floor_number: unitFileData?.unitInfo?.floor_number,
                building_id: 1,
                is_occupied: unitFileData?.unitInfo?.is_occupied,
                created_on: new Date(),
            }} />
        </Box>
    }

    const showMetrics = () => {
        return <Paper elevation={3} sx={{mb: 2, borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                {metricInfo.map((metric) => {
                    return buildInfoCard(metric.icon, metric.metric, metric.value);
                })}
            </Box> 
        </Paper>
    }


    return (
        <>
        <Paper elevation={5} sx={{mb: 2, padding: 3, borderRadius: 3}}>
            {getHeaderInfo()}
            {unitFileData &&  <>
                {showOwnerInfo()}
                {showMetrics()}
                {buildTabs()}
                {buildTable(currentTab)}
            </>}
        </Paper>
        </>
    )
}

export default ViewUnitFile;